export const trimObject = (obj, exceptions) => {
  Object.keys(obj).forEach(key => {
    if (exceptions?.some(val => key === val)) return
    if (obj[key] === false || obj[key] === 0) return
    !obj[key] && delete obj[key]
  })
}
